import { useTranslations } from '@vocab/react';

import { ApplicationStatus } from 'src/components/ApplicationStatus/ApplicationStatus';
import { useAppConfig } from 'src/config/context';

import translations from './MostRecentStatus.vocab';

interface Props {
  appliedDate: string;
  appliedDateHiddenVisually: string;
  viewedDate?: string;
  viewedDateHiddenVisually?: string;
  notSuitableDate?: string;
  notSuitableDateHiddenVisually?: string;
  isExternal: boolean;
}

export const MostRecentStatus = ({
  appliedDate,
  appliedDateHiddenVisually,
  viewedDate,
  viewedDateHiddenVisually,
  notSuitableDate,
  notSuitableDateHiddenVisually,
  isExternal,
}: Props) => {
  const { t } = useTranslations(translations);
  const { BRAND: brand } = useAppConfig();

  return (
    <>
      {isExternal ? (
        <ApplicationStatus
          label={t('Applied off')}
          tone="positive"
          date={appliedDate}
          dateUtc={appliedDateHiddenVisually}
        />
      ) : null}

      {notSuitableDate && !isExternal ? (
        <ApplicationStatus
          label={t('Unlikely to progress')}
          tone="neutral"
          date={notSuitableDate}
          dateUtc={notSuitableDateHiddenVisually}
        />
      ) : null}

      {viewedDate && !isExternal && !notSuitableDate ? (
        <ApplicationStatus
          label={t('Viewed by employer')}
          tone="positive"
          date={viewedDate}
          dateUtc={viewedDateHiddenVisually}
        />
      ) : null}

      {appliedDate && !isExternal && !notSuitableDate && !viewedDate ? (
        <ApplicationStatus
          label={t('Applied on', { brand })}
          tone="positive"
          date={appliedDate}
          dateUtc={appliedDateHiddenVisually}
        />
      ) : null}
    </>
  );
};
